import { Grid, Paper, Tab, Tabs, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";



const ThreeComponent = ({
    ComponentOne, 
    ComponentTwo, 
    ComponentThree, 
    tabsTitle, 
    useTabsNameAsTitle, 
    excludeCardsToComponents, 
    excludeTitleToComponents, 
    defaultSelectedTab = 0,
    componentsSizes = [],
}: any) => {
    const theme = useTheme();
    const [selectedTab, setSelectedTab] = useState(useMediaQuery(theme.breakpoints.down('sm')) 
                                            ? defaultSelectedTab 
                                            : 1);
    if (componentsSizes.length && componentsSizes.length !== 3) {
        console.error("you must specify sizes por the three componens.");
    }
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTab(newValue);
    };

    return (
        <Grid container spacing="1rem" >
            <Grid item xs={12} sx={{mt: {xs: ".5rem", md: 0}}}>
                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    centered
                    indicatorColor="primary"
                    textColor="primary"
                    sx={{display: {xs: "block", md: "none"}}}
                >
                    <Tab style={{padding: '10px'}} label={tabsTitle[0]} sx={{display: {xs: "block", sm: "none"}}} />
                    <Tab style={{padding: '10px'}} label={tabsTitle[1]} />
                    <Tab style={{padding: '10px'}} label={tabsTitle[2]}/>
                </Tabs>
            </Grid>
            <Grid 
                item 
                {...(componentsSizes?.length && componentsSizes[0] 
                    ? componentsSizes[0]
                    : {
                        xs: 12,
                        sm: 6,
                        md: 4
                    }
                )}
                sx={{
                    display: {xs: selectedTab !== 0 ? "none" : "block", sm: "block"}
                }}
            >
                {!excludeCardsToComponents?.includes(0)
                    ? <Paper
                            elevation={3}
                            style={{
                                width: "100%", 
                                borderRadius: "0.5rem",
                                minHeight: "10rem",
                                padding: "1.5rem"
                            }}
                        >
                            {useTabsNameAsTitle && !excludeTitleToComponents?.includes(0) && <Typography variant="h6" style={{color: theme.s10palette.S10Greygrey600, marginBottom: ".5rem"}}>
                                {tabsTitle[0]}
                            </Typography>}
                            <ComponentOne />    
                        </Paper>
                    : <>
                        {useTabsNameAsTitle && !excludeTitleToComponents?.includes(0) && <Typography variant="h6" style={{color: theme.s10palette.S10Greygrey600, marginBottom: ".5rem"}}>
                            {tabsTitle[0]}
                        </Typography>}
                        <ComponentOne />
                    </>
                }
                
            </Grid>
            
            <Grid
                item 
                {...(componentsSizes?.length && componentsSizes[1] 
                    ? componentsSizes[1]
                    : {
                        xs: 12,
                        sm: 6,
                        md: 4
                    }
                )}
                pt="1rem"
                pl="1rem"
                sx={{
                    display: {xs: selectedTab !== 1 ? "none" : "block", sm: selectedTab === 2 ? "none" : "block", md: "block"}
                }}
            >
                {!excludeCardsToComponents?.includes(1)
                    ? <Paper
                            elevation={3}
                            style={{
                                width: "100%", 
                                borderRadius: "0.5rem",
                                minHeight: "10rem",
                                padding: "1.5rem"
                            }}
                        >
                            {useTabsNameAsTitle && !excludeTitleToComponents?.includes(1) && <Typography variant="h6" style={{color: theme.s10palette.S10Greygrey600, marginBottom: ".5rem"}}>
                                {tabsTitle[1]}
                            </Typography>}
                            <ComponentTwo />    
                        </Paper>
                    : <>
                        {useTabsNameAsTitle && !excludeTitleToComponents?.includes(1) && <Typography variant="h6" style={{color: theme.s10palette.S10Greygrey600, marginBottom: ".5rem"}}>
                            {tabsTitle[1]}
                        </Typography>}
                        <ComponentTwo />
                    </>
                }
            </Grid>
            <Grid 
                item 
                {...(componentsSizes?.length && componentsSizes[2] 
                    ? componentsSizes[2]
                    : {
                        xs: 12,
                        sm: 6,
                        md: 4
                    }
                )}          
                sx={{
                    display: {xs: selectedTab !== 2 ? "none" : "block", md: "block"}
                }}
            >
                {!excludeCardsToComponents?.includes(2)
                    ? <Paper
                            elevation={3}
                            style={{
                                width: "100%", 
                                borderRadius: "0.5rem",
                                minHeight: "10rem",
                                padding: "1.5rem"
                            }}
                        >
                            {useTabsNameAsTitle && !excludeTitleToComponents?.includes(2) && <Typography variant="h6" style={{color: theme.s10palette.S10Greygrey600, marginBottom: ".5rem"}}>
                                {tabsTitle[2]}
                            </Typography>}
                            <ComponentThree />    
                        </Paper>
                    : <>
                        {useTabsNameAsTitle && !excludeTitleToComponents?.includes(2) && <Typography variant="h6" style={{color: theme.s10palette.S10Greygrey600, marginBottom: ".5rem"}}>
                            {tabsTitle[2]}
                        </Typography>}
                        <ComponentThree />
                    </>
                }
            </Grid>
        </Grid>
    )

}

export default ThreeComponent